import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import { Box, Icon, Link } from "@quarkly/widgets";
import { useOverrides } from "../hooks";
import { FaFacebook, FaYoutube, FaWhatsapp, FaTumblr, FaInstagram, FaTwitter, FaGooglePlus, FaViber, FaSnapchat, FaVk, FaPinterest, FaLinkedinIn, FaTelegram, FaReddit, FaFlickr, FaFoursquare, FaDiscord, FaGithubAlt } from "react-icons/fa";
var social = [{
  icon: FaFacebook,
  propName: "facebook"
}, {
  icon: FaWhatsapp,
  propName: "whatsapp"
}, {
  icon: FaTumblr,
  propName: "tumblr"
}, {
  icon: FaInstagram,
  propName: "instagram"
}, {
  icon: FaTwitter,
  propName: "twitter"
}, {
  icon: FaGooglePlus,
  propName: "google-plus"
}, {
  icon: FaViber,
  propName: "viber"
}, {
  icon: FaSnapchat,
  propName: "snapchat"
}, {
  icon: FaVk,
  propName: "vkontakte"
}, {
  icon: FaPinterest,
  propName: "pinterest"
}, {
  icon: FaLinkedinIn,
  propName: "linked-in"
}, {
  icon: FaTelegram,
  propName: "telegram"
}, {
  icon: FaReddit,
  propName: "reddit"
}, {
  icon: FaYoutube,
  propName: "youtube"
}, {
  icon: FaFlickr,
  propName: "flikr"
}, {
  icon: FaFoursquare,
  propName: "foursquare"
}, {
  icon: FaDiscord,
  propName: "discord"
}, {
  icon: FaGithubAlt,
  propName: "github"
}];
var socialProps = social.reduce(function (acc, _ref) {
  var propName = _ref.propName;
  return _objectSpread({}, acc, _defineProperty({}, propName, true));
}, {});

var filterProps = function filterProps(props) {
  var result = {};

  for (var propName in props) {
    if (!socialProps[propName]) {
      result[propName] = props[propName];
    }
  }

  return result;
};

var defaultProps = {
  display: "flex",
  "icon-size": "24px",
  "align-items": "center",
  "justify-content": "center"
};
var overrides = {
  icon: {
    props: {}
  },
  link: {
    kind: "Link",
    props: {
      padding: "8px",
      margin: "0 4px",
      color: "--primary",
      background: "--color-lightD1",
      "hover-background": "--color-lightD2",
      "border-radius": "4px"
    }
  }
};

var SocialMedia = function SocialMedia(_ref2) {
  var size = _ref2["icon-size"],
      props = _objectWithoutProperties(_ref2, ["icon-size"]);

  var _useOverrides = useOverrides(filterProps(props), overrides, defaultProps),
      override = _useOverrides.override,
      rest = _useOverrides.rest;

  return /*#__PURE__*/React.createElement(Box, rest, social.map(function (_ref3) {
    var propName = _ref3.propName,
        icon = _ref3.icon;
    if (!props[propName]) return null;
    return /*#__PURE__*/React.createElement(Link, _extends({
      key: propName,
      href: props[propName],
      target: "_blank"
    }, override("link", "link-".concat(propName))), /*#__PURE__*/React.createElement(Icon, _extends({
      icon: icon,
      size: size
    }, override("icon", "icon-".concat(propName)))));
  }));
};

var propInfo = {
  "icon-size": {
    control: "input",
    transformer: "pixel",
    category: "Main"
  }
};
social.map(function (_ref4) {
  var propName = _ref4.propName;
  propInfo[propName] = {
    weight: 1,
    control: "input",
    category: "Social Links"
  };
});
Object.assign(SocialMedia, {
  defaultProps: defaultProps,
  overrides: overrides,
  propInfo: propInfo
});
export default SocialMedia;